/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum PackageVersionType {
	Property = 0,
	Transfer = 1,
}

/** @format int32 */
export enum PackageVersionStatus {
	Pending = 0,
	Installed = 1,
	Failed = 2,
	Cancelled = 3,
	Superseded = 4,
}

/** @format int32 */
export enum MachineTransferStatus {
	Pending = 0,
	Completed = 1,
	Cancelled = 2,
}

/** @format int32 */
export enum MachineCloudConfigContinent {
	Northamerica = 0,
}

/** @format int32 */
export enum MachineCertificateStatus {
	None = 0,
	Active = 1,
	Revoked = 2,
}

export interface CreateMachineTransferRequest {
	/** @format uuid */
	machineId: string;
	/** @format uuid */
	toOrganization: string;
	notes?: string | null;
}

export interface MachineCredentialDto {
	/** @format uuid */
	MachineId: string;
	MachineName: string;
	/** @format uuid */
	AccountId: string;
	AccountName?: string | null;
	CertificateStatus: MachineCertificateStatus;
	Attributes: Record<string, string>;
}

export interface MachineCredentialDtoPagedResult {
	Items: MachineCredentialDto[];
	NextPageToken?: string | null;
}

export interface MachineTransferData {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	FromOrganization: string;
	FromOrganizationName?: string | null;
	/** @format uuid */
	ToOrganization: string;
	ToOrganizationName?: string | null;
	Status: MachineTransferStatus;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	/** @format uuid */
	CreatedBy: string;
	CreatedByEmail: string;
	Notes?: string | null;
	CertificateId: string;
	CertificateArn: string;
	/** @format uuid */
	PackageId: string;
}

export interface MachineTransferListItemDto {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	/** @format uuid */
	FromOrganization: string;
	FromOrganizationName?: string | null;
	/** @format uuid */
	ToOrganization: string;
	ToOrganizationName?: string | null;
	Status: MachineTransferStatus;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	/** @format uuid */
	CreatedBy: string;
	CreatedByEmail: string;
	Notes?: string | null;
	/** @format uuid */
	PackageId: string;
}

export interface MachineTransferListItemDtoPageResponse {
	Data: MachineTransferListItemDto[];
	/** @format int32 */
	Page: number;
	/** @format int32 */
	PageSize: number;
	/** @format int32 */
	TotalCount: number;
	/** @format int32 */
	TotalPages: number;
	HasNextPage: boolean;
}

export interface PackageVersionData {
	/** @format uuid */
	Id: string;
	/** @format uuid */
	MachineId: string;
	Type: PackageVersionType;
	Status: PackageVersionStatus;
	/** @format date-time */
	CreatedAt: string;
	/** @format date-time */
	UpdatedAt: string;
	S3DebianKey?: string | null;
	S3ZipKey?: string | null;
}

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<
	D extends unknown,
	E extends unknown = unknown,
> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			key => "undefined" !== typeof query[key],
		);
		return keys
			.map(key =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean"
				? secure
				: this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter =
			this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async response => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat
				? response.clone()
				: response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then(data => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch(e => {
							r.error = e as E;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) {
				const error = Object.assign(
					new Error(
						`HTTP ${data.status}: ${data.statusText || "Error"}`,
					),
					{
						status: data.status,
						statusText: data.statusText,
						data: data.data,
						error: data.error,
						response: data,
						json: data.json.bind(data),
						text: data.text.bind(data),
					},
				);

				throw error;
			}
			return data;
		});
	};
}

/**
 * @title MachineCertificateLambda
 * @version 1.0
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	machinecertificate = {
		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachineCredentials
		 * @request GET:/machinecertificate/credentials/{accountId}/machines
		 */
		getMachineCredentials: (
			accountId: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto[], void>({
				path: `/machinecertificate/credentials/${accountId}/machines`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name AddMachineCredential
		 * @request POST:/machinecertificate/credentials/{accountId}/machines
		 */
		addMachineCredential: (
			accountId: string,
			data: MachineCredentialDto,
			query?: {
				continent?: MachineCloudConfigContinent;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/machines`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name UpdateMachineCredential
		 * @request PUT:/machinecertificate/credentials/{accountId}/machines
		 */
		updateMachineCredential: (
			accountId: string,
			data: MachineCredentialDto,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/machines`,
				method: "PUT",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachines
		 * @request GET:/machinecertificate/credentials/v2/{accountId}/machines
		 */
		getMachines: (
			accountId: string,
			query?: {
				pageToken?: string;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<
				MachineCredentialDtoPagedResult,
				ProblemDetails | void
			>({
				path: `/machinecertificate/credentials/v2/${accountId}/machines`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetAllMachineCredentials
		 * @request GET:/machinecertificate/credentials/machines
		 */
		getAllMachineCredentials: (
			query?: {
				attributeName?: string;
				attributeValue?: string;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto[], void>({
				path: `/machinecertificate/credentials/machines`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetAllMachines
		 * @request GET:/machinecertificate/credentials/v2/machines
		 */
		getAllMachines: (
			query?: {
				pageToken?: string;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDtoPagedResult, void>({
				path: `/machinecertificate/credentials/v2/machines`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachineCredentialsByFleet
		 * @request GET:/machinecertificate/credentials/{accountId}/machines/fleet/{fleet}
		 */
		getMachineCredentialsByFleet: (
			accountId: string,
			fleet: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto[], void>({
				path: `/machinecertificate/credentials/${accountId}/machines/fleet/${fleet}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachinesByFleet
		 * @request GET:/machinecertificate/credentials/v2/{accountId}/machines/fleet/{fleet}
		 */
		getMachinesByFleet: (
			accountId: string,
			fleet: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDtoPagedResult, void>({
				path: `/machinecertificate/credentials/v2/${accountId}/machines/fleet/${fleet}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachineCredential
		 * @request GET:/machinecertificate/credentials/{accountId}/machines/{machineId}
		 */
		getMachineCredential: (
			accountId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/machines/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name DeleteMachine
		 * @request DELETE:/machinecertificate/credentials/{accountId}/machines/{machineId}
		 */
		deleteMachine: (
			accountId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/machines/${machineId}`,
				method: "DELETE",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachine
		 * @request GET:/machinecertificate/credentials/v2/{accountId}/machines/{machineId}
		 */
		getMachine: (
			accountId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/v2/${accountId}/machines/${machineId}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetPendingPackages
		 * @request GET:/machinecertificate/credentials/{machineId}/packages/pending
		 */
		getPendingPackages: (machineId: string, params: RequestParams = {}) =>
			this.request<PackageVersionData[], void>({
				path: `/machinecertificate/credentials/${machineId}/packages/pending`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name CompleteMachinePackage
		 * @request POST:/machinecertificate/credentials/{machineId}/packages/{packageId}/complete
		 */
		completeMachinePackage: (
			machineId: string,
			packageId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${machineId}/packages/${packageId}/complete`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name CreateMachineTransfer
		 * @request POST:/machinecertificate/credentials/{accountId}/transfers
		 */
		createMachineTransfer: (
			accountId: string,
			data: CreateMachineTransferRequest,
			params: RequestParams = {},
		) =>
			this.request<MachineTransferData, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/transfers`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetAccountTransfers
		 * @request GET:/machinecertificate/credentials/{accountId}/transfers
		 */
		getAccountTransfers: (
			accountId: string,
			query?: {
				status?: MachineTransferStatus;
				/**
				 * @format int32
				 * @default 1
				 */
				page?: number;
				/**
				 * @format int32
				 * @default 1000
				 */
				pageSize?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<
				MachineTransferListItemDtoPageResponse,
				ProblemDetails | void
			>({
				path: `/machinecertificate/credentials/${accountId}/transfers`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name GetMachineTransfers
		 * @request GET:/machinecertificate/credentials/{accountId}/machines/{machineId}/transfers
		 */
		getMachineTransfers: (
			accountId: string,
			machineId: string,
			query?: {
				status?: MachineTransferStatus;
			},
			params: RequestParams = {},
		) =>
			this.request<MachineTransferListItemDto[], ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/machines/${machineId}/transfers`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name CancelMachineTransfer
		 * @request POST:/machinecertificate/credentials/{machineId}/transfers/{transferId}/cancel
		 */
		cancelMachineTransfer: (
			machineId: string,
			transferId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${machineId}/transfers/${transferId}/cancel`,
				method: "POST",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name ZipAllPackages
		 * @request POST:/machinecertificate/credentials/{accountId}/zipallpackages
		 */
		zipAllPackages: (
			accountId: string,
			query?: {
				fleet?: string;
				onlyDebian?: boolean;
			},
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/zipallpackages`,
				method: "POST",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Credential
		 * @name CreateRemoteSupportCertificate
		 * @request POST:/machinecertificate/credentials/{accountId}/remotesupport
		 */
		createRemoteSupportCertificate: (
			accountId: string,
			data: MachineCredentialDto,
			params: RequestParams = {},
		) =>
			this.request<MachineCredentialDto, ProblemDetails | void>({
				path: `/machinecertificate/credentials/${accountId}/remotesupport`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Ping
		 * @name PingList
		 * @request GET:/machinecertificate/Ping
		 */
		pingList: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/machinecertificate/Ping`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Ping
		 * @name PingInfoDetail
		 * @request GET:/machinecertificate/Ping/info/{firstName}/{lastName}
		 */
		pingInfoDetail: (
			firstName: string,
			lastName: string,
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/machinecertificate/Ping/info/${firstName}/${lastName}`,
				method: "GET",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Ping
		 * @name PingCreate
		 * @request POST:/machinecertificate/Ping/{data}
		 */
		pingCreate: (data: string, params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/machinecertificate/Ping/${data}`,
				method: "POST",
				...params,
			}),
	};
	machinecertificateMachineApi = {
		/**
		 * No description
		 *
		 * @tags MachineAccess
		 * @name GetPendingPackagesMachine
		 * @request GET:/machinecertificate-machine-api/{machineId}/packages/pending
		 */
		getPendingPackagesMachine: (
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<PackageVersionData[], void>({
				path: `/machinecertificate-machine-api/${machineId}/packages/pending`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAccess
		 * @name DownloadMachinePackage
		 * @request GET:/machinecertificate-machine-api/{machineId}/packages/{packageId}/download/{packageType}
		 */
		downloadMachinePackage: (
			machineId: string,
			packageId: string,
			packageType: string,
			params: RequestParams = {},
		) =>
			this.request<string, ProblemDetails | void>({
				path: `/machinecertificate-machine-api/${machineId}/packages/${packageId}/download/${packageType}`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags MachineAccess
		 * @name MachineCompletePackage
		 * @request POST:/machinecertificate-machine-api/{machineId}/packages/{packageId}/complete
		 */
		machineCompletePackage: (
			machineId: string,
			packageId: string,
			params: RequestParams = {},
		) =>
			this.request<void, ProblemDetails | void>({
				path: `/machinecertificate-machine-api/${machineId}/packages/${packageId}/complete`,
				method: "POST",
				...params,
			}),
	};
}
